export default "dist/images/block-columns-plain.4f998ec.png";